<template>
  <v-dialog persistent 
            v-model="dialog"
            :lazy="true"
            width="50%"
            >
                <v-btn slot="activator"
                    text-color="white"
                    class="d-inline-block bg_white custom_pos_column"
                >
                <svg viewBox="0 0 24 24" class="customIcon i_header">
                  <path fill="#000000" d="M3,3H11V5H3V3M13,3H21V5H13V3M3,7H11V9H3V7M13,7H21V9H13V7M3,11H11V13H3V11M13,11H21V13H13V11M3,15H11V17H3V15M13,15H21V17H13V15M3,19H11V21H3V19M13,19H21V21H13V19Z" />
                </svg>
                <small> Colunas</small>
                </v-btn>
                <v-card>
                    <v-card-title
                    
                    class="headline darkBlue"
                    text-color="white"
                    style="color: white;"
                    >
                    Organizar colunas da tabela
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeModal('cancelar')">
                        <v-icon>close</v-icon>
                    </v-btn>
                    </v-card-title>

                    <v-card-text id="tst">
                <v-layout align-start justify-start row fill-height >
                      <btnRmvColumn :table="table" :empresa="empresa"></btnRmvColumn>
                      <btnNewColumn :table="table" :empresa="empresa"></btnNewColumn>
                      <v-tooltip bottom>
                                    <v-btn slot="activator" 
                                        color="indigo darken-4"
                                        icon
                                        flat
                                        text-color="white"
                                        dark
                                        
                                        @click.native="resetHeaders()">
                                      <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                                          <path fill="#000000" d="M11,4C13.05,4 15.09,4.77 16.65,6.33C19.78,9.46 19.77,14.5 16.64,17.64C14.81,19.5 12.3,20.24 9.91,19.92L10.44,17.96C12.15,18.12 13.93,17.54 15.24,16.23C17.58,13.89 17.58,10.09 15.24,7.75C14.06,6.57 12.53,6 11,6V10.58L6.04,5.63L11,0.68V4M5.34,17.65C2.7,15 2.3,11 4.11,7.94L5.59,9.41C4.5,11.64 4.91,14.39 6.75,16.23C7.27,16.75 7.87,17.16 8.5,17.45L8,19.4C7,19 6.12,18.43 5.34,17.65Z" />
                                      </svg>
                                    </v-btn>
                                    <span>Voltar colunas para o padrão do motor fiscal</span>
                                </v-tooltip>
                </v-layout >
                        <v-divider></v-divider>
                        <v-container grid-list-md>
                        <v-layout row wrap>
                            
                                
                                <div class="lista-colunas" id="colItensAtivas">
                                <v-layout align-end justify-end row >
                                    <v-tooltip bottom>
                                    <v-btn slot="activator" 
                                        color="indigo darken-4"
                                        icon
                                        flat
                                        text-color="white"
                                        dark
                                        
                                        @click.native="addAllColumn(table.auxHeaders)">
                                    <v-icon class="material-icons"  dark color="indigo darken-4" style="padding-right: 10px;">reply_all</v-icon>
                                    </v-btn>
                                    <span>Ativar todas as colunas</span>
                                </v-tooltip>
                                </v-layout>
                                <!-- <v-chip color="red" text-color="white" @click.native="removeAllColumn(table.auxHeaders)">Remover todas colunas</v-chip> -->
                                <h3 class="text-xs-center">Colunas Ocultas</h3>
                                <ul>
                                    <li v-for="header in table.auxHeaders" :key="header.text" v-if="headerShow(header,'oculta')" @click="addColumn(header.value)">
                                        <v-btn outline block :color="header.value.indexOf('custom') == -1 ? 'red accent-4' : 'pink darken-4'" text-color="white">{{header.text}}
                                          
                                        </v-btn>
                                    </li>
                                </ul>
                                </div>
                            
                                <div class="lista-colunas" id="colItensOcultos">
                                <!-- <v-chip color="green" text-color="white" @click.native="addAllColumn(table.auxHeaders)">Adicionar todas colunas</v-chip> -->
                                    <v-layout align-end justify-start row>
                                    <v-tooltip bottom>
                                    <v-btn slot="activator" 
                                            color="red darken-4"
                                            icon
                                            flat
                                            text-color="white"
                                            dark
                                            @click.native="removeAllColumn(table.auxHeaders)">
                                        <v-icon class="material-icons"  dark color="red darken-4" style="padding-right: 10px;">reply_all</v-icon>
                                    

                                    </v-btn>
                                    <span>Ocultar todas as colunas</span>
                                    </v-tooltip>
                                </v-layout>
                                
                                <h3 class="text-xs-center">Colunas Ativas</h3>


                                <draggable id="listaHeader" element="ul" v-model="table.auxHeaders" :move="onMove" :options="dragOptions"  @start="isDragging=true" @end="onEnd">
                                  <transition-group type="transition" :name="'flip-list'">
                                    <li class="parent v-btn v-btn--block v-btn--outline v-btn--depressed" v-for="(header,index)  in this.table.auxHeaders" :key="header.text"
                                    @click="removeColumn(header.value, $event)" v-if="headerShow(header,'ativa')" v-show="header.show"
                                     :class="header.value.indexOf('custom') == -1 ? ' indigo darken-4' : ' teal'"
                                    >
                                      <span class="desc_header_titulo">{{header.text}}</span>
                                      <span class="badge">{{index}}</span>
                                      <v-icon class="material-icons up" color="red" dark @click="orderUp(header.value)">arrow_drop_up</v-icon>
                                      <v-icon class="material-icons down" color="red" dark @click="orderDown(header.value)">arrow_drop_down</v-icon>
                                    </li>
                                  </transition-group>
                                </draggable>
                              </div>
                            
                        </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="red"
                        flat
                        @click="closeModal('cancelar')"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="success"
                        
                        @click="closeModal('salvar')"
                    >
                        Salvar
                    </v-btn>
                    </v-card-actions>
                </v-card>
    </v-dialog>

</template>

<script>
import btnNewColumn from "./btnNewColumn/BtnNewColumn.vue";
import NfeService from "@/domain/notas/nfe/NfeService";
import btnRmvColumn from "./btnRmvColumn/BtnRmvColumn.vue";
import draggable from "vuedraggable";
import CommonService from "@/domain/dataTable/commonService/CommonService.js";
export default {
  props: ["headers", "table", "component", "empresa", "conta"],
  components: {
    btnNewColumn: btnNewColumn,
    btnRmvColumn: btnRmvColumn,
    draggable
  },
  data: () => ({
    dialog: false,
    qnt: 0,
    editable: true,
    isDragging: false,
    delayedDragging: false
  }),
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    dialog: function() {
      this.table.auxHeaders = this.table.headers.slice();
      this.table.auxNotas = [];
    },
    "table.headers": function(newV) {
      if (newV.length != this.table.auxHeaders.length) {
        this.table.auxHeaders = newV.slice();
        this.table.auxNotas = [];
      }
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.table.auxHeaders = this.table.headers.slice();
    });
  },
  methods: {
    resetHeaders() {
      try {
        var arrayCustom = [];
        this.table.auxHeaders.forEach(x => {
          if (x.value.indexOf("custom_") != -1) {
            arrayCustom.push(x);
          }
        });
        this.table.snack.show = true;
        this.table.snack.text = "Colunas ordenadas no padrão motor fiscal";
        this.table.snackSuccess();
        this.table.auxHeaders = this.table.getHeaders();
        if (arrayCustom.length > 0) {
          arrayCustom.forEach(x => {
            this.table.auxHeaders.push(x);
          });
        }
      } catch (error) {
        throw new Error("Não foi possível resetar os headers: " + error);
      }
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    onEnd({ relatedContext, draggedContext }) {},
    headerShow(header, action) {
      if (header.enable && action == "ativa" && header.show) {
        return true;
      } else if (!header.enable && action == "oculta") {
        return false;
      } else if (!header.enable && action == "ativa") {
        return false;
      }
      if (!header.show && action == "oculta") return true;
      if (header.show && action == "ativa") return true;
    },
    orderUp(idItem) {
      var posItem;
      var auxItemAnt;

      for (var i = 0; i < this.table.auxHeaders.length; i++) {
        if (this.table.auxHeaders[i].value == idItem) {
          posItem = i;
        }
      }
      auxItemAnt = this.table.auxHeaders[posItem - 1];
      this.table.auxHeaders.splice(
        posItem - 1,
        1,
        this.table.auxHeaders[posItem]
      );
      this.table.auxHeaders.splice(posItem, 1, auxItemAnt);
    },
    orderDown(idItem) {
      var posItem;
      var auxProxItem;

      for (var i = 0; i < this.table.auxHeaders.length; i++) {
        if (this.table.auxHeaders[i].value == idItem) {
          posItem = i;
        }
      }
      auxProxItem = this.table.auxHeaders[posItem + 1];
      this.table.auxHeaders.splice(
        posItem + 1,
        1,
        this.table.auxHeaders[posItem]
      );
      this.table.auxHeaders.splice(posItem, 1, auxProxItem);
    },
    addAllColumn(headers) {
      let funcao = this.toggleDisplayBody;

      headers.forEach(function(item) {
        if (item.enable) {
          item.show = true;
          funcao(item.value, "table-cell");
        }
      });
    },
    addColumn(idItem) {
      this.toggleDisplayItens(this.table.auxHeaders, idItem, true);
    },
    removeAllColumn(headers) {
      let funcao = this.toggleDisplayBody;
      headers.forEach(function(item) {
        if (item.enable) {
          item.show = false;
          funcao(item.value, "none");
        }
      });
    },
    removeColumn(idItem, $event) {
      if ($event.target.nodeName != "I") {
        this.toggleDisplayItens(this.table.auxHeaders, idItem, false);
      }
    },
    toggleDisplayBody(idItem, display) {
      var id = "#" + idItem;
      document.querySelectorAll(id).forEach(item => {
        if (item.nodeName == "TD") {
          item.style.display = display;
        } else {
          item.style.display = "inline-block";
        }
      });
    },
    toggleDisplayItens(array1, idItem, action) {
      //Header da tabela
      let posItem;
      for (let i = 0; i < array1.length; i++) {
        if (array1[i].value == idItem) {
          posItem = i;
        }
      }
      let display = "none";
      if (action) display = "table-cell";
      this.toggleDisplayBody(idItem, display);
      this.table.auxHeaders[posItem].show = action;

      let qntHeaders = document.querySelectorAll("#listaHeader li").length;
      if (action) {
        qntHeaders += 1;
      }
      let item = this.table.auxHeaders[posItem];
      this.table.auxHeaders.splice(posItem, 1);
      this.table.auxHeaders.splice(qntHeaders, 0, item);
    },
    closeModal: async function(acao) {
      switch (acao) {
        case "salvar":
          this.table.headers = [];

          this.table.headers = this.table.auxHeaders.slice();

          let auxNotas = this.table.array_todas_notas;
          let tableAux = this.table.auxNotas;
          let arrayNfe = [];
          let i = 0;
          var cont_c_column = 0;
          while (i < auxNotas.length) {
            let objNfe = {};
            cont_c_column = 0;
            this.table.auxHeaders.forEach(item => {
              if (item.value.indexOf("acoes") == -1) {
                let newObjNota = "";
                if (this.table.auxNotas.length > 0) {
                  this.table.auxNotas.forEach(element => {
                    if (element == item.value) {
                      newObjNota = {};
                      newObjNota["value"] = "";
                      newObjNota["key"] = item.value;

                      objNfe[item.value] = newObjNota;
                    } else {
                      if (auxNotas[i][item.value] != undefined) {
                        newObjNota = auxNotas[i][item.value];
                      }
                    }
                  });
                } else {
                  if (auxNotas[i][item.value] != undefined) {
                    newObjNota = auxNotas[i][item.value];
                  }
                }
                objNfe[item.value] = newObjNota;
                if (item.show) {
                  document.querySelectorAll(`#${item.value}`).forEach(item => {
                    item.display = "table-cell";
                    item.removeAttribute("style");
                  });
                }
              }
            });
            arrayNfe.push(objNfe);
            i++;
          }
          this.table.array_todas_notas = arrayNfe.slice();
          this.table.arrayNotas = arrayNfe.slice();

          var arrayHeaders = [];

          this.table.auxHeaders.forEach(item => {
            var obj = {};
            obj["titulo"] = item.text;
            obj["id"] = item.value;
            obj["show"] = item.show;
            obj["pesq"] = item.pesq;
            obj["enable"] = item.enable;

            arrayHeaders.push(obj);
          });
          var serv = new CommonService(this.$http);
          await serv
            .saveHeadersByEmp(
              this.empresa._id,
              arrayHeaders,
              this.component.name,
              this.component.tipo
            )
            // .then(x => {
            //   if(x.ok){
            //     this.conta.getEmpresas = true
            //   }
            // });
      }
      if(this.table.addedCustomColumn){
        this.table.showSnackAtt = true;
      }
      this.dialog = false;
    }
  }
};
</script>
<style scoped>
/* li{
  display: block!important;
} */
.lista-colunas {
  width: 46%;
  margin: 0 2% 0 0;
}
.lista-colunas ul {
  height: 40vh;
  list-style-type: none;
  overflow: auto;
}
.lista-colunas ul::-webkit-scrollbar {
  position: absolute;
  width: 5px;
}
.lista-colunas ul::-webkit-scrollbar-thumb {
  background: #23578abf;
  width: 5px;
  position: absolute;
  top: 0px;
  opacity: 0.8;
  display: block;
  border-radius: 7px;
  z-index: 99;
  right: -20px;

  visibility: visible;
}
#colItensAtivas i {
  transform: rotateY(180deg);
}
#listaHeader i {
  position: absolute;
  right: 20px;
  z-index: 2;
}
#listaHeader li:first-of-type .down {
  height: 100%;
}
#listaHeader li:last-of-type .down {
  display: none;
}
#listaHeader li:last-of-type .up {
  height: 100%;
  position: absolute;
  top: 0;
}
#listaHeader li {
  cursor: move;
  border-radius: 6px;
}
#listaHeader li:first-of-type .up {
  display: none;
}
.up {
  top: 0;
  right: 20px;
}
.down {
  height: 50%;
  bottom: 0;
}
.d-none {
  display: none;
}
.badge {
  position: absolute;
  left: 20px;
  background-color: #009688;
  padding: 3px;
  border-radius: 50%;
  color: white;
  font-size: 10px;
  width: 20px;
  height: 20px;
  text-align: center;
}
.desc_header_titulo {
  white-space: nowrap;
  width: 68%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/dataTable/commonTable/actionsHeader/btnColumn/BtnColumn.vue